<template>
  <div>
    <n-bread
        v-bind:content="{bread_list, bread_active}"
    ></n-bread>
    <!-- big tab -->


<!--    <div class="mb-3 border" style="width: 100%; margin-left: 1px; background-color: #FFFF02; border-color: #EF7B10 !important; border-radius: 5px">-->
<!--      <div class="p-4">-->
<!--        <div>-->
<!--          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6" style="height:38px;">-->
<!--            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />-->
<!--          </svg>-->

<!--        </div>-->
<!--        <div>-->
<!--          <strong style="font-size: 24px">Avviso</strong><br>-->
<!--          Stiamo riscontrando problemi di collegamento con il portale immobiliare.it. Pertanto la creazione e l'aggiornamento delle zone mappate potrebbe non funzionare correttamente. <br>-->
<!--          Il team di Real Estate Pro è al lavoro per risolvere il problema.-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->





    <div v-if="CHECK_ROLE_SIDEBAR(100)">
      <div class="row">
        <div class="col">
          <div class="abtg-wrapper-tab">
            <a href="#" @click="showTab('map')" class="abtg-tab" :class="activeMap">
              <h4>{{ $t('dashboard.mappatura').toUpperCase() }}</h4>
            </a>
            <!--                    <a href="#" @click="showTab('scan')" class="abtg-tab" :class="activeScan">-->
            <!--                        <h4>{{$t('dashboard.scan_di_mercato').toUpperCase()}}</h4>-->
            <!--                    </a>-->

            <!--                                      <a  @click="disattivaScan = 1"  class="abtg-tab" :class="activeScan">-->
            <!--                                          <h4>{{$t('dashboard.scan_di_mercato').toUpperCase()}}</h4>-->
            <!--                                          <span v-if="disattivaScan === 1" style="color:white; line-height:12px;" >Servizio temporanemente sospeso <br>per aggiornamenti.</span>-->
            <!--                                      </a>-->
          </div>
        </div>
      </div>
      <div class="row">
        <div v-if="activeMap" class="col">
          <div class="abtg-content-tab">

            <div class="row abtg-mb-20">
              <div class="col" v-if="activeMap" v-html="$t('dashboard.descrizione_mappatura')">

              </div>
               <div class="col" v-if="!activeMap">


                <p>Esegui lo scan di mercato copiando ed incollando la stringa di ricerca direttamente da
                  <strong>immobiliare.it</strong>
                  <br>ed individuare velocemente le operazioni da
                  approfondire. </p>

              </div>
            </div>
            <div class="row" v-if="myError">

              <ul v-for="e in myError">
                <li class="abtg-error-message">{{ e[0] }}</li>
              </ul>
            </div>

            <div class="row abtg-mb-20">
              <div class="col">
                {{ $t('dashboard.citta') }}
                <div class="input-icon right">

                  <i class="fas fa-building " data-original-title="success input!"></i>
                  <Autocomplete :items="citiesAutoComplete"
                                filterby="comune"
                                @input="cityListByName"

                                style="background-color:white"
                                @selected="citySelected"></Autocomplete>
                </div>
              </div>
              <div class="col">
                {{ $t('dashboard.zona') }}
                <div class="input-icon right">
                  <i class="fas fa-building " data-original-title="success input!"></i>
                  <input type="text" style=""
                         v-model="zone"
                         class="form-control  "/>
                </div>
              </div>

              <div class="col">
                {{ $t('dashboard.macro_zona') }}
                <div class="input-icon right">
                  <i class="fas fa-building " data-original-title="success input!"></i>
                  <input type="text" style=""
                         v-model="macrozone"
                         class="form-control  "/>
                </div>
              </div>
              <div class="col">
                {{ $t('dashboard.micro_zona') }}
                <div class="input-icon right">
                  <i class="fas fa-building " data-original-title="success input!"></i>
                  <input type="text" style=""
                         v-model="microzone"
                         class="form-control  "/>
                </div>
              </div>

            </div>

            <div class="row" v-if="!activeMap">
              <div class="col">
                <div class="input-icon right">
                  <i class="fas fa-globe " data-original-title="success input!"></i>
                  <input type="text" placeholder="URL di ricerca*" style=""
                         v-model="address"
                         class="form-control  "/>
                </div>
              </div>

              <div class="col text-right">
                <button
                    v-if="!activeMap"
                    @click="settingZoneData('scan')"
                    class="btn btn-success  abtg__btn-third shadow-none abtg-button-big">
                  Esegui lo scan di mercato
                </button>
              </div>
            </div>

            <div class="row" v-if="activeMap">
              <div class="col text-right">
                <button
                    @click="settingZoneData('mapping')"
                    class="btn btn-success  abtg__btn-third shadow-none abtg-button-big">
                  {{ $t('dashboard.salva_disegna') }}
                </button>


              </div>
            </div>

          </div>


        </div>

      </div>
    </div>
    <!-- end big tab -->

     <!-- closed operation, active operations, ecc-->


    <div class="row">
      <div class="col">
        <transition name="fade" mode="out-in">
          <n-starred


          ></n-starred>
        </transition>
      </div>
    </div>
    <!-- end closed operation, active operations, ecc-->

    <div class="row">
      <div class="col-lg-8">
        <!-- google calendar -->
        <n-calendar></n-calendar>
        <!-- end google calendar -->
      </div>


      <div class="col-lg-4"
           v-if="!CHECK_ROLE_SIDEBAR(100) || !CHECK_ROLE_SIDEBAR(200)"
      >
        <div class="card abtg__default-card abtg__default-card-border">
          <div class="card-head" style="height:60px;">
            <header>{{ $t('dashboard.acquista_pacchetto') }}</header>

          </div>
          <div class="card-body ">
            <a href="https://alfiobardolla.lpages.co/"
               target="_blank"><img
                v-if="CHECK_ROLE_SIDEBAR(100) &&  !CHECK_ROLE_SIDEBAR(200)  "
                src="/img/promo/aste.png" class="img-fluid"/>
              <img
                  v-if="CHECK_ROLE_SIDEBAR(200) && !CHECK_ROLE_SIDEBAR(100)  "
                  src="/img/promo/mercato.png" class="img-fluid"/>
            </a>
          </div>
        </div>


      </div>
    </div>



  </div>
</template>

<script>
import {roles} from '@/helpers/roles';
import NBread from '@/partials/bread';
import NStarred from '@/partials/dashboard/starred_buildings';
import NPopover from '@/partials/popover';
import Autocomplete from '@/partials/autocomplete';
import NCalendar from '@/partials/dashboard/calendar';
import mappa from '@/partials/clickMap/mappa'
import {mapActions, mapState, mapMutations} from 'vuex';
import {mixin} from "@/helpers/helper";
import Popover from "../../partials/popover.vue";

export default {
  mixins: [mixin, roles],
  data() {
    return {
      disattivaScan: 0,
      zone: null,
      macrozone: null,
      microzone: null,
      address: null,
      city_id: 0,
      region: null,
      activeMap: 'tab-active',
      activeScan: null,
    }
  },
  components: {
    Popover,
    NBread, NStarred, NPopover, Autocomplete, NCalendar, mappa
  },
  created() {
    this.trackActivity();
    this.lang = window.localStorage.getItem("language");

    if (this.lang === 'es') {
      this.SET_DATA({name: 'bread_active', data: {label: 'Tu Panel de control'}});
    } else {
      this.SET_DATA({name: 'bread_active', data: {label: 'La tua dashboard'}});
    }

  },

  watch: {
    zoneSavedData(oldValue, newValue) {
      if ((oldValue) !== (newValue)) {
        this.$router.push({path: '/mapping/search/' + this.zoneSavedData.zoneId + '/' + this.zoneSavedData.region});
      }
    }
  },
  computed: {
    ...mapState('n_dashboard', ['bread_active', 'bread_list', 'componentKey'
    ]),
    ...mapState('n_mapping', ['citiesAutoComplete', 'zoneSavedData', 'zoneSaved', 'myError'])
  },
  methods: {
    ...mapActions('n_dashboard', ['']),
    ...mapActions('n_mapping', ['cityListByName', 'sendZoneData']),
    ...mapMutations('n_dashboard', ['SET_DATA']),

    trackActivity()
    {
      axios.get('/api/v2/trackactivity/track')
          .then(() => {

          })
    },

    simulateFading() {
      let self = this;
      setTimeout(function () {
        self.show = !this.show;
      }, 250);
    },

    citySelected(city) {
      //  console.log(`Customer Selected:\nid: ${city.id}\nname: ${city.comune}`);
      this.city_id = city.id;
      this.region = city.regione;
    },
    settingZoneData(searchType) {
      this.$store.commit('n_mapping/SET_DATA', {name: 'showAllZonesButton', data: false});
      this.sendZoneData({
        zone: this.zone,
        macrozone: this.macrozone,
        microzone: this.microzone,
        city_id: this.city_id, region: this.region,
        searchType: searchType,
        address: this.address,
      });
    },

    showTab(whatTab) {
      switch (whatTab) {
        case 'scan':
          this.activeMap = null;
          this.activeScan = 'tab-active';
          break;
        case 'map':
          this.activeMap = 'tab-active';
          this.activeScan = null;
          break;
      }
    }


  }
}
</script>


